const AR = {
  // Currency
  currency: "ريال سعودي",

  // Buttons Labels Repeated
  "modal-ok-btn": "موافق",
  "send-btn": "إرسال",
  "cancel-btn": "إلغاء",

  // ==========================================================================================================================================
  // Error Messages
  "phone-number-error": "يرجى إدخال رقم الهاتف",
  "password-error": "يرجى إدخال كلمة المرور",
  "confirm-password-error": "يرجى تأكيد كلمة المرور",
  "user-name-error": "يرجى إدخال اسم المستخدم",
  "confirm-code-error": "يرجى إدخال الكود",

  // Input Error Messages
  "user-name-input-error": "يرجى التأكد من صحة اسم المستخدم المدخل",
  "phone-number-input-error": "يرجى التأكد من صحة رقم الهاتف المدخل",
  "password-input-error": "يرجى التأكد من صحة كلمة المرور المدخلة",
  "confirm-password-input-error": "يرجى تأكيد كلمة المرور بشكل صحيح",
  // ==========================================================================================================================================
  // Navbar
  "arabic-key": "عربي",
  "english-key": "انكليزي",
  "urdu-key": "اوردو",
  "hindi-key": "هندي",
  "main-tab": "الرئيسية",
  "notification-tab": "الاشعارات",
  "orders-tab": "تتبع الطلبات",
  "settings-tab": "الاعدادات",
  "user-name": "اسم المستخدم",
  "sign-out": "تسجيل الخروج",
  // ==========================================================================================================================================
  // StartUp
  "Startup-form-header": "نظف أغراضك",
  "Startup-box-text-1": "لديك الكثير من الأشياء التي تحتاج إلى التنظيف؟",
  "Startup-box-text-2": "استرخ واتصل بنا لتنظيف كل ما تحتاجه",
  "Startup-box-text-3": "ماذا تنتظر؟ انضم إلينا الآن",
  "Lets-start-btn": "هيّا بنا !",

  // Copy Rights Start
  "copy-rights-start-1": "هل لديك اي سؤال؟",
  "copy-rights-start-2": "تواصل معنا",
  "copy-rights-start-3": "تطبيق خدمات التنظيف",
  "copy-rights-start-4": "| جميع الحقوق محفوظة",
  "copy-rights-start-5": "تطوير شركة التشفير المعاصر للحلول التقنية",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "تسجيل الدخول",
  "login-phone-number-label": "رقم الهاتف",
  "login-phone-number-text": "لن نشارك رقم هاتفك مع أي شخص آخر.",
  "login-phone-number-placeholder": "رقم الهاتف",
  "login-password-label": "كلمة المرور",
  "login-password-placeholder": "كلمة المرور",
  "login-btn-text": "تسجيل الدخول",
  "login-no-account-text": "لا تملك حسابا حتى الآن؟",
  "login-no-account-signup": "انشاء حساب",
  "login-method-text": "أو تسجيل الدخول باستخدام",
  "login-method-1-text": "Google",
  "login-method-2-text": "Apple",

  // ==========================================================================================================================================
  // SignUp
  "signup-form-header": "انشاء حساب",
  "confirm-signup-form-header": "خطوة التحقق",
  "confirm-signup-please-input-code": "من فضلك قم بإدخال رمز التحقق",
  "confirm-signup-code-is-sent-to": "تم إرسال الرمز للرقم: ",
  "confirm-signup-ask-if-receive-code": "لم تستلم الرمز؟ ",
  "confirm-signup-re-send-code": "إعادة الإرسال",
  "confirm-signup-verify-code": "تحقق",
  "confirm-signup-close-code": "العودة",
  "signup-phone-number-text": "لن نشارك رقم هاتفك مع أي شخص آخر.",
  "signup-phone-number-placeholder": "رقم الهاتف",
  "signup-user-name-placeholder": "اسم المستخدم",
  "building-number": "رقم البناء",
  "floor-number": "رقم الطابق",
  "signup-password-placeholder": "كلمة المرور",
  "signup-password-confirm-placeholder": "تأكيد كلمة المرور",
  "signup-btn-text": "انشاء حساب",
  "signup-method-text": "أو أنشئ حساب باستخدام",
  "signup-method-1-text": "Google",
  "signup-method-2-text": "Apple",

  // ==========================================================================================================================================
  // Main
  // Main Navbar
  "search-main-tab": "البحث عن مغسلة",
  "fav-main-tab": "المفضلة",
  "recently-main-tab": "المستخدم مؤخراً",
  "request-main-tab": "طلب خدمة",

  // ==========================================================================================================================================
  // Search Washer
  "Search-box-placeholder": "ابحث من خلال الاسم...",
  "laundry-location-label-card": "موقع المغسل: ",
  "rate-filter-search-washer": "الأكثر تقييماً",
  "near-filter-search-washer": "الأقرب",
  "rate-max-to-min": "من الأكثر تقييماً إلى الأقل",
  "rate-min-to-max": "من الأقل تقييماً إلى الأكثر",
  "choose-city": "اختر مدينة",
  "sort-starting-with": "رتب بدءاً من",
  "discount-label": "تخفيض",
  "free-deliver-label": "توصيل مجاني",
  "no-laundromats": "لا يوجد مغاسل بعد",

  // ==========================================================================================================================================
  // Laundry Modal
  "laundry-services-label": "خدمات المغسلة: ",
  "request-service-button": "طلب خدمة",
  "move-to-map-button": "الانتقال إلى الخريطة",
  "services-laundry-table-column": "الخدمات المقدمة معها",
  "size-laundry-table-column": "حجم الخدمة",

  // ==========================================================================================================================================
  // Service Request
  "choose-type": "اختر نوع",
  "choose-type-first": "اختر نوع القطعة أولاً",
  "check-box-take-your-order": "أخذ طلبك و إعادته إليك عن طريق مندوبي التوصيل",
  "choose=service-type-select-option": "اختر نوع الخدمة",
  "send-request-service": "إرسال الطلب",
  "specify-current-location": "حدد موقعك الحالي:",
  "span-under-location-row":
    "*سيتم أخذ إحداثيات موقعك الحالي بشكل تلقائي لتسهيل وصول العميل إليك",
  "no-services-yet": "لا يوجد خدمات أخرى",
  "price-after-discount": "السعر بعد التخفيض:",
  "price-after-free-delivery": "السعر بعد خصم أجار التوصيل:",

  // ==========================================================================================================================================
  // Settings
  // Settings Navbar
  "password-settings-tab": "كلمة المرور",
  "user-info-settings-tab": "معلومات المستخدم",
  "location-settings-tab": "الموقع",
  "Terms-Conditions-settings-tab": "الشروط و الأحكام",
  "system-work-settings-tab": "عمل النظام",
  // ==========================================================================================================================================
  // System Change Password
  "system-user-name-change-label": "اسم المستخدم",
  "system-phone-change-label": "رقم الهاتف",
  "system-old-password-change-label": "كلمة المرور القديمة",
  "system-password-change-label": "كلمة المرور الجديدة",
  "system-confirm-password-change-label": "تأكيد كلمة المرور الجديدة",
  "system-password-btn-change-label": "تأكيد",
  // ==========================================================================================================================================
  // System Change Location
  "system-location-change-label": "موقعك الحالي",
  "system-location-change-note":
    "في حال ضبط الموقع بشكل يدويّ، الرجاء تحديده بدقة",
  "system-location-btn-auto-label": "ضبط الموقع اوتوماتيكياً",
  "system-location-btn-change-label": "تأكيد",
  // ==========================================================================================================================================
  // System Work
  Bronze: "برونزي",
  Silver: "فضي",
  Gold: "ذهبي",
  Diamond: "ألماسي",

  // ==========================================================================================================================================
  // Notifications
  // Notifications Texts
  "Laundry-Accept": "تم قبول طلبك من المغسلة",
  "Laundry-Reject": "تم رفض طلبك من المغسلة",
  "Delivery-Accept": "تم استلام طلبك من المندوب",
  "Laundry-Received-order": "وصل طلبك إلى المغسلة وسنخبرك عند الانتهاء منه",
  "Laundry-start-washing-notification": "تفاصيل طلبك هو",
  "Laundry-finish-washing-ready-Delivering": "تم الانتهاء من طلبك",
  "Free-Delivery-notif":
    "لقد قامت المغسلة بعرض توصيل مجاني على طلباتها، هذا العرض يشمل المستخدمين الذهبيين.",
  "Discount-notif":
    "لقد قامت المغسلة بخصم بنسبة () ريال سعودي للمستخدمين الذهبيين عند الطلب من هذه المغسلة.",
  "Delivered-state": "تم تسليم طلبكم بنجاح",
  "order-num-notification": "رقم الطلب: ",
  "rate-send-notification": "كيف كانت تجربتك؟ ",
  "note-send-notification": "ماهي ملاحظاتك؟ ",

  // Notifications Table details
  "item-type-column-notification": "نوع القطعة",
  "service-type-column-notification": "نوع الخدمة",
  "number-of-items-column-notification": "عدد القطع",
  "price-column-notification": "التكلفة",

  // ==========================================================================================================================================
  // Orders
  // Orders Navbar
  "my-orders-nav": "طلباتي",
  "done-orders-nav": "طلباتي المنجزة",

  // Order Statuses
  "Waiting-Laundry-Accept": "قيد انتظار قبول المغسلة",
  "Waiting-Delivery-Accept": "قيد انتظار موافقة استلام المندوب",
  "Delivery-Taking-Order-from-user": "قيد الاحضار من العميل",
  "Delivery-Taking-Order-to-Laundry": "قيد الاحضار للمغسلة",
  "Waiting-Laundry-start-washing": "قيد بدء التنفيذ",
  "Laundry-start-washing": "قيد التنفيذ",
  "Ready-to-Deliver": "جاهز للتسليم",
  "Waiting-Delivery-Taking-Accept": "قيد انتظار موافقة التسليم للمندوب",
  "Delivery-ReturnBack-Order-from-Laundry": "قيد الاحضار من المغسلة ",
  "Delivery-ReturnBack-Order-to-user": "قيد الاحضار للعميل",
  "Delivered-order-to-user": "تم التسليم",

  // Order Labels
  "Laundry-name-label-order": "اسم المغسل: ",
  "Delivery-name-label-order": "اسم المندوب: ",
  "Date-label-order": "تاريخ إنشاء الطلب: ",
  "Type-label-order": "نوع الطلب: ",
  "details-name-btn-order": "تفاصيل الطلب",

  // Order Details Modal and Table
  "item-type-column": "نوع القطعة",
  "service-type-column": "نوع الخدمة",
  "number-of-items-column": "عدد القطع",
  "price-column": "التكلفة",
  "price-label-modal": "السعر الإجمالي: ",
  "price-cost-label-modal": "التكلفة: ",
  "price-commission-label-modal": "العمولة: ",

  // delivering Orders Types
  "delivery-two-ways": "يؤخذ و يرد عن طريق المندوبين",
  "delivery-one-way": "يؤخذ عن طريق المندوبين فقط",

  // ==========================================================================================================================================

  // Contact Us

  // ******  Headers
  "contactUs-header": "تواصل معنا",
  "first-contactUs-header": "معلومات التواصل",
  "second-contactUs-header": "اترك لنا رسالة",

  // ******  Communicate Column
  "location-communicate-label": "العنوان",
  "location-communicate-value": "الأردن الأردن الأردن",
  "phone-communicate-label": "الهاتف",
  "phone-communicate-value": "0999999999",
  "email-communicate-label": "البريد الالكتروني",
  "email-communicate-value": "example@gmail.com",

  // ******  send message Column
  "name-label": "الاسم",
  "name-placeholder": "اسمك",
  "email-send-message-label": "البريد الالكتروني",
  "email-send-message-placeholder": "example@gmail.com",
  "message-contactUs-label": "الرسالة",
  "message-contactUs-placeholder": "ماذا تريد إخبارنا",
  "button-send-message-contactUs": "إرسال",

  // ==========================================================================================================================================
};

export default AR;
